import http from "../http-common";

class PermissionService {
  getAll() {
    return http.get('/permissions');
  }

  get(id) {
    return http.get(`/permissions/${id}`);
  }

  create(data) {
    return http.post('/permissions', data);
  }

  update(id, data) {
    return http.put(`/permissions/${id}`, data);
  }

  delete(id) {
    return http.delete(`/permissions/${id}`);
  }
}

export default new PermissionService();
